import { Modal } from "react-bootstrap";
import { Button } from "../../components/button";
import { GenericForm } from "../../components/generic-form";

import { UpdateLabelModalProps } from "./Labels.types";
import { useTranslation } from "react-i18next";

const UpdateLabelModal = ({
  isVisible,
  onDismiss,
  onSubmit,
  updating,
  updateLabelForm,
}: UpdateLabelModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal show={isVisible} animation onHide={onDismiss}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          {t("LABELS.UPDATE_TITLE")}
        </h5>
        <div onClick={onDismiss}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <GenericForm
          form={updateLabelForm}
          onSubmit={onSubmit}
          submitControl={(submit) => (
            <div className="flex-row">
              <Button
                isLoading={updating}
                loader={{ size: "s" }}
                className="btn btn-primary mt-3 w-100"
                type="submit"
              >
                {t("SAVE_BUTTON")}
              </Button>
            </div>
          )}
        />
      </Modal.Body>
    </Modal>
  );
};

export default UpdateLabelModal;
